import { PeriodDataPage } from "@/pages/dashboard/perioddata/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/dashboard/period-data")({
    component: PeriodDataPage,
});
